import type { JSX } from "react";
import { CopyButton } from "../atoms/CopyButton.tsx";

/** A shell command shown as code, with a copy button beside it. */
export function CommandCopy({ command }: { command: string }): JSX.Element {
  return (
    <div className="home-command">
      <code>{command}</code>
      <CopyButton text={command} label="Copy" />
    </div>
  );
}
